import { render, staticRenderFns } from "./usa_pr_card.vue?vue&type=template&id=1992c321&"
import script from "./usa_pr_card.vue?vue&type=script&lang=js&"
export * from "./usa_pr_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports